export default __webpack_public_path__ + "static/media/img-soon-1.22f6c222.svg";